import { createContext } from "react";
const CompanyLogoContext = createContext({});
export default CompanyLogoContext;
